import React from "react"
import { Link } from "@reach/router"
import "../styles/App.scss"
import kila_cover from "../static/kila_cover.png"

const provider = ""

const Card = props => {
  return (
    <>
      <div className="card hoverable">
        <div className="card-image waves-effect waves-block waves-light">
          {props.image !== undefined ? (
            <img
              className="activator"
              src={`${props.image[0].url}`}
              alt="obra"
            />
          ) : (
            <img className="activator" src={kila_cover} alt="obra" />
          )}
        </div>
        <div className="card-content">
          <span className="title card-title activator grey-text text-darken-4">
            {props.description.length > 80
              ? props.description.slice(0, 80).concat("...")
              : props.description}
            <i className="material-icons right">more_vert</i>
          </span>
          <p className="link">
            <Link to={`/building/${props.id}`}>Ver mas &rarr;</Link>
          </p>
        </div>
        <div className="card-reveal">
          <span className="card-title grey-text text-darken-4">
            {props.item}
            <i className="material-icons right">close</i>
          </span>
          <p>{props.description}</p>
          <p className="link">
            <Link to={`/${props.id}/documents`}>Ir a Documentación</Link>
          </p>
        </div>
      </div>
    </>
  )
}

export default Card
